import type { IAction } from '../../action/IAction'
import { Field, InputType } from 'type-graphql'
import type { PaymentGatewayObject } from '../PaymentGatewayObject'
import type { PaymentGatewayProvider } from '../PaymentGatewayProviderEnum'

@InputType()
export class CaptureCardPaymentArgs {
  @Field(() => String)
  paymentId?: string

  @Field(() => Number)
  amount: number

  @Field(() => String)
  gatewayProvider?: PaymentGatewayProvider
}

export interface ICaptureCardPayment extends IAction<PaymentGatewayObject, CaptureCardPaymentArgs> {}
